import { computed, state } from 'ccstate'
import { apiClient$ } from '../infra/apiClient'
import type { SortOption, SortDirection, ViewMode } from '../../common/schema/schemaType'

export const fileExplorerState = {
  // Current folder ID
  currentFolderId$: state<string | null>('root'),

  // View preferences
  viewMode$: state<ViewMode>('grid'),
  sortBy$: state<SortOption>('name'),
  sortDirection$: state<SortDirection>('asc'),

  // Search
  searchQuery$: state<string>(''),

  // Selection
  selectedFileIds$: state<string[]>([]),

  // UI state
  isCreatingFolder$: state<boolean>(false),
  isUploading$: state<boolean>(false),
  showDetailsPanel$: state<boolean>(false),

  // Data refresh triggers
  filesDirty$: state<number>(1),
  storageDirty$: state<number>(1),

  // Computed values
  currentFiles$: computed(async (get) => {
    get(fileExplorerState.filesDirty$) // Refresh trigger
    const apiClient = get(apiClient$)
    const currentFolderId = get(fileExplorerState.currentFolderId$) as string | null
    const sortBy = get(fileExplorerState.sortBy$) as SortOption
    const sortDirection = get(fileExplorerState.sortDirection$) as SortDirection

    const result = await apiClient.getApi('getFiles', {
      parentId: currentFolderId,
      sortBy,
      sortDirection
    })
    return result.files
  }),

  searchResults$: computed(async (get) => {
    const searchQuery = get(fileExplorerState.searchQuery$) as string
    if (!searchQuery.trim()) {
      return { files: [], totalCount: 0 }
    }

    const apiClient = get(apiClient$)
    const currentFolderId = get(fileExplorerState.currentFolderId$) as string | null

    return await apiClient.getApi('searchFiles', {
      query: searchQuery,
      parentId: currentFolderId
    })
  }),

  storageInfo$: computed(async (get) => {
    get(fileExplorerState.storageDirty$) // Refresh trigger
    const apiClient = get(apiClient$)
    return await apiClient.getApi('getStorageInfo', {})
  }),

  breadcrumbPath$: computed(async (get) => {
    const currentFolderId = get(fileExplorerState.currentFolderId$) as string | null
    get(fileExplorerState.filesDirty$) // Refresh when files change

    if (!currentFolderId || currentFolderId === 'root') {
      return [{ id: 'root', name: 'My Files' }]
    }

    // For prototype, simple breadcrumb
    return [{ id: 'root', name: 'My Files' }]
  }),

  selectedFiles$: computed(async (get) => {
    const selectedIds = get(fileExplorerState.selectedFileIds$) as string[]
    const currentFiles = await get(fileExplorerState.currentFiles$) as any[]

    return currentFiles.filter((file: any) => selectedIds.includes(file.id))
  })
}